import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.widgetMessageData`;
export const INIT = `${SCOPE}/INIT`;

export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const SET_LOADING_STATE = `${SCOPE}/SET_LOADING_STATE`;
export const SET_RESPONSE = `${SCOPE}/SET_RESPONSE`;
export const SET_ACTIVE_TAB = `${SCOPE}/SET_ACTIVE_TAB`;
